
import {getGamerList} from '../api/getGamerList';
import {setGetGamerListAction} from '../action';

const setGetGamerList = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getGamerList(params);
    
            if (data.status === 'success') {
                dispatch(setGetGamerListAction({
                    list: data.data.list,
                    count: data.data.count
                }));
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetGamerList
}